import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import SectionTitle from "../../components/SectionTitles/SectionTitle";
import NewGif from "../../components/Gif/NewGif";

const AnnouncementItem = ({ headline, detail, showBadge = true, className = "" }) => (
  <li className={`announcement-item ${className}`}>
    <h5>
      <div className="announcement-entry">
        {showBadge && (
          <span className="announcement-badge">
            <NewGif />
          </span>
        )}
        <div className="announcement-content">
          <p className="announcement-headline">{headline}</p>
          {detail && <p className="announcement-detail">{detail}</p>}
        </div>
      </div>
    </h5>
  </li>
);

AnnouncementItem.propTypes = {
  headline: PropTypes.node.isRequired,
  detail: PropTypes.node,
  showBadge: PropTypes.bool,
  className: PropTypes.string,
};

const ServiceIconBox = ({ classOption }) => {
  const publicUrl = process.env.PUBLIC_URL;

  return (
    <div className={`section section-padding-t50-b80 ${classOption}`}>
      <div className="container">
        <SectionTitle title="Announcement" />
        <div className="row row-cols-1 mb-n6" id="anounce">
          <ul className="li-align">
            <AnnouncementItem
              headline="ICSI'2026 has successfully concluded in Beijing!"
              detail={
                <>
                  Thank you to all authors, speakers, organizers, sponsors, and
                  participants. Conference photos are now available in the{" "}
                  <Link to={`${publicUrl}/gallery`}>Gallery</Link>.
                </>
              }
            />

            <AnnouncementItem
              headline="Congratulations to the Best Paper and Best Student Papers!"
              detail={
                <div className="award-list">
                  <p>
                    <strong>Best Paper</strong>
                    <br />
                    <em>
                      Improving Competitive Swarm Optimizer via Adaptive Spiral
                      Search Mechanism
                    </em>
                    <br />
                    Yang Cao, Yuefeng Xu, Jun Yu, Rui Zhong, Masaharu Munetomo
                  </p>
                  <p>
                    <strong>Best Student Papers</strong>
                  </p>
                  <p>
                    <em>
                      Underwater Dual-arm Synchronous Control Based on Cross
                      Coupling Strategy and Model Predictive Control
                    </em>
                    <br />
                    Tianping Hou, Shibo Su, Wenkai Zhang, Yilun Sun, Qirong Tang
                  </p>
                  <p>
                    <em>
                      Machine Learning Models for Predicting Outpatient Waiting
                      Time in Maternal and Child Healthcare: A Comparative Study
                    </em>
                    <br />
                    Jiaqi Xie, Tingting Liu, Ben Niu (Corresponding author)
                  </p>
                </div>
              }
            />

            <AnnouncementItem
              headline="Accepted papers are proceeding through normal publication"
              detail={
                <>
                  All accepted ICSI&apos;2026 papers have entered the standard
                  publication workflow and are currently being processed. Final
                  proceedings will be released on the official conference website
                  when available.
                </>
              }
            />

            <AnnouncementItem
              showBadge={false}
              headline={
                <>
                  Selected excellent papers will be recommended for a Special
                  Issue of{" "}
                  <span className="announcement-deadline">
                    International Journal of Information Technology &amp;
                    Decision Making (IJITDM)
                  </span>
                  .
                </>
              }
              detail={
                <>
                  Outstanding contributions from the conference may be invited
                  for extended publication in this prestigious journal.
                </>
              }
            />
          </ul>
        </div>

        <div className="space-100"></div>

        <div className="conference-ind" />
      </div>
    </div>
  );
};

ServiceIconBox.propTypes = {
  classOption: PropTypes.string,
};
ServiceIconBox.defaultProps = {
  classOption: "section section-padding-t90-b100",
};

export default ServiceIconBox;
